export default __webpack_public_path__ + "static/media/header-mfs.f167df52.svg";